// extracted by mini-css-extract-plugin
export default {"menu":"Navigation__menu__0hb-p"};